<template>
  <div class="dialog-body" v-on:close="onClose">
    <h1>
      Convert BPoints to
      <b class="brand-name-element"></b>
    </h1>

    <div class="info-container">
      <form
        id="convert_form"
        method="POST"
        :action="this.url"
        name="convert-form"
        @submit="submit"
      >
        <input type="hidden" name="_token" :value="csrf">
        <input type="hidden" id="partner" name="partner">
        <input type="hidden" id="partner_name" name="partnerName">
        <input type="hidden" id="memberUIDNumberInputName" name="memberUIDNumberInputName">
        <input type="hidden" id="conversionRatio" name="conversionRatio" v-model="conversionRatio">
        <input
          type="hidden"
          id="binf_number"
          name="binfNumber"
          :value="selectedCard !== null ? selectedCard.card_no : null"
        >
        <div class="form-group card-selector">
          <label class="required-label">SELECT YOUR B INFINITE CARD</label>
          <div class="dropdown">
            <button
              class="btn btn-secondary dropdown-toggle form-control"
              type="button"
              id="bcardDdMenuBtn"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              aria-describedby="pointsAvailable"
            >
              {{ isSelected ? 'BCard&nbsp;' + selectedCard.card_no : 'Select card' }}
              <span
                class="caret"
                v-if="!isSelected"
              ></span>
              <span class="balance-text" v-if="isSelected">
                Available
                Points
                <span
                  class="pink"
                >{{ formatPoints(selectedCard.lms_BalancePoint) }}</span>
              </span>
            </button>
            <div class="dropdown-menu col-12" aria-labelledby="bcardDdMenuBtn">
              <!-- <a class="dropdown-item readonly">
                <small>Select card</small>
              </a> -->
              <a
                class="dropdown-item"
                v-for="card in this.parseObject"
                :key="card.id"
                :value="card"
                v-on:click="setSelectedCard(card, $event)"
              >
                BCard&nbsp;{{ card.card_no }}
                <span class="balance-text no-caret">
                  Available
                  Points
                  <span
                    class="pink"
                  >{{ formatPoints(card.lms_BalancePoint) }}</span>
                </span>
              </a>
            </div>
          </div>
          <p style="color:red;">
            <span id="pointsAvailable" class="form-text text-muted">
              <span
                v-if="isSelected && selectedCard.lms_BalancePoint > 0 && selectedCard.lms_BalancePoint >= blockPoints"
              >Convertable up to {{ calcConvertablePoints() }} <span class="brand-name-element">{{ this.brandName }}</span>&nbsp;</span>
              <span
                v-if="isSelected && selectedCard.lms_BalancePoint < blockPoints"
                style="color: red;"
              >Insufficient BPoints balance</span>
            </span>
          </p>
        </div>
        <div class="form-group">
          <label class="required-label">B Infinite Card PIN</label>
          <input
            class="form-control col-md-5"
            type="password"
            id="bcard_pin"
            placeholder="Your PIN for authorization"
            name="bcardPIN"
            v-model="bcardPIN"
            :readonly="isSubmitting"
            required
            oninvalid="this.setCustomValidity('Please fill in the required field')"
            oninput="this.setCustomValidity('')"
          >
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label class="required-label">FULL NAME</label>
            <input
              class="form-control"
              type="text"
              id="bcard_f_name"
              name="bcardFName"
              v-model="bcardFName"
              readonly
              required
              oninvalid="this.setCustomValidity('Please fill in the required field')"
              oninput="this.setCustomValidity('')"
            >
          </div>
          <!-- <div class="form-group col-md-6">
            <label class="required-label">LAST NAME {{ partner }}</label>
            <input
              class="form-control"
              type="text"
              id="bcard_l_name"
              name="bcardLName"
              v-model="bcardLName"
              :readonly="isSubmitting"
              required
              oninvalid="this.setCustomValidity('Please fill in the required field')"
              oninput="this.setCustomValidity('')"
            >
          </div> -->
        </div>
        <div class="form-row">
          <div class="form-group col-md-4">
            <label class="required-label">CONTACT NUMBER</label>
            <input
              class="form-control"
              type="number"
              id="mobile_number"
              name="mobileNumber"
              v-model="mobileNumber"
              :readonly="isSubmitting"
              required
              oninvalid="this.setCustomValidity('Please fill in the required field')"
              oninput="this.setCustomValidity('')"
            >
          </div>
          <div class="form-group col-md-8">
            <label class="required-label">EMAIL</label>
            <input
              class="form-control"
              type="email"
              id="email"
              name="email"
              v-model="email"
              :readonly="isSubmitting"
              required
              oninvalid="this.setCustomValidity('Please fill in the required field')"
              oninput="this.setCustomValidity('')"
            >
          </div>
        </div>
        <div class="form-group">
          <label id="memberUID" class="required-label">memberUID</label>
          <input
            class="form-control"
            type="text"
            id="member_uid_number"
            name="memberUidNumber"
            placeholder="Insert here..."
            v-model="memberUidNumber"
            :readonly="isSubmitting"
            required
            oninvalid="this.setCustomValidity('Please fill in the required field')"
            oninput="this.setCustomValidity('')"
          >
        </div>
        <div v-if="partner=='airasia'" class="form-group">
            <label class="required-label">AirAsia Member LAST NAME</label>
            <input
              class="form-control"
              type="text"
              id="bcard_l_name"
              name="bcardLName"
              v-model="bcardLName"
              :readonly="isSubmitting"
              required
              oninvalid="this.setCustomValidity('Please fill in the required field')"
              oninput="this.setCustomValidity('')"
            >
          </div>
        <div class="form-group" style="margin-bottom: 0">
          <label class="required-label">BPOINTS TO CONVERT (MIN  {{ blockPoints }} BPOINTS)</label>
          <input
            class="form-control col-md-5"
            :class=" { 'is-invalid': errors['bpointsAmount'] } "
            type="number"
            placeholder="Insert points..."
            min="0"
            v-model="bpointsAmount"
            :max="maxPoints"
            :step="blockPoints"
            @input="validatePoints"
            :readonly="isSubmitting"
            :disabled="!isSelected"
            required
          >
          <small v-if="errors['bpointsAmount']" class="text-danger">{{ errors['bpointsAmount'] }}</small>
          <span id="pointsAvailable" class="form-text text-muted"
              v-if="!errors['bpointsAmount'] && isSelected && pointsConvertAmount > 0">
          <span>Converts to {{ formatPoints(pointsConvertAmount) }}</span>
              <span class="brand-name-element">{{ this.brandName }}</span>&nbsp;
          </span>
        </div>
        <div style="margin-top: 15px"></div>
        <input type="hidden"
            id="point_convert_amount"
            name="pointsConvertAmount"
            v-model="pointsConvertAmount">
        <input type="hidden"
            id="bpoint_amount"
            name="bpointsAmount"
            v-model="bpointsAmount"
            >
        <input type="hidden"
            id="block_point"
            name="blockPoints"
            v-model="blockPoints"
            >
        <div v-if="errorMessage != ''" class>{{ errorMessage }}</div>
        <button
          id="convert_points_button"
          type="submit"
          class="btn btn-blue"
          :disabled="!isCanSubmit"
        >CONTINUE TO CONVERT</button>
      </form>
    </div>
  </div>
</template>

<script>
var data = {
      csrf: null,
      selectedCard: null,
      bcardPIN: "",
      memberUidNumber: "",
      bpointsAmount: 0,
      isSelected: false,
      isSubmitting: false,
      errorMessage: "",
      conversionRatio: 1,
      blockPoints: 100,
      errors: {},
      partner:''
    };
// Terribly sorry for this hack.. Gotta make sure this stuff is done
// Gives ability to change the vue data from front
window.convertPointsDialogData = data;
export default {
  // Note: data-cards, data-f-name and data-l-name becomes camel case in props
  props: [
    "dataCards",
    "dataFName",
    "dataLName",
    "dataMobile",
    "dataEmail",
  ],

  data() {
    var csrfElement = document
        .querySelector('meta[name="csrf-token"]')
    if (csrfElement.getAttribute("content")) {
      data['csrf'] = csrfElement.getAttribute("content");
    }
    data['url'] = this.$routes["member_points_convert"];
    data['cards'] = this.dataCards;
    data['bcardFName'] = this.dataFName;
    data['bcardLName'] = this.dataLName;
    data['mobileNumber'] = this.dataMobile;
    data['email'] = this.dataEmail;
    return data;
  },
  methods: {

    setSelectedCard: function(card, e) {
      e.preventDefault();

      this.selectedCard = card;
      this.isSelected = this.selectedCard !== null;

      this.brandName = document.getElementById("partner_name").value;
    },

    formatPoints: function(value) {
      let val = (value / 1).toFixed(0);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    calcConvertablePoints: function() {
      return this.formatPoints(this.maxConvertedAmount);
    },

    onClose: function() {
      this.selectedCard = null;
      this.isSelected = false;
    },

    validatePoints: function() {
      if (this.selectedCard) {
        this.$delete(this.errors, 'bpointsAmount');
        // Must be sufficient
        if (parseInt(this.selectedCard.lms_BalancePoint) < this.blockPoints) {
          this.$set(this.errors, 'bpointsAmount', `Insufficient BPoints balance`);
          return;
        }

        // Must not be 0
        if (this.bpointsAmount <= 0) {
          this.$set(this.errors, 'bpointsAmount', `Cannot be less than ${this.blockPoints}`);
          return;
        }

        // Less than max
        if (this.bpointsAmount > this.maxPoints) {
          this.$set(this.errors, 'bpointsAmount', `Cannot exceed maximum points of ${this.maxPoints}`);
          return;
        }

        // Must be divisible by block points
        if (this.bpointsAmount % this.blockPoints != 0) {
          this.$set(this.errors, 'bpointsAmount', `Must be in block of ${this.blockPoints} points`);
          return;
        }
      }

      return 0;
    },

    submit: function(e) {
      this.validatePoints();
      if (_.isEmpty(this.errors)) {
        this.isSubmitting = true;
      } else {
        e.preventDefault();
      }
    }
  },
  computed: {
    parseObject: function() {
      return JSON.parse(this.dataCards);
    },

    maxPoints: function() {
      if (this.selectedCard) {
        var balance = this.selectedCard.lms_BalancePoint;
        return balance - (balance % this.blockPoints);

        // if (balance > this.blockPoints) {
        //   return (balance - (balance % this.blockPoints)) * ratio;
        // }

        // return balance * ratio;
      }

      return 0;
    },

    isCanSubmit: function() {
      return !this.isSubmitting &&
        this.selectedCard != null &&
        _.isEmpty(this.errors) &&
        parseInt(this.bpointsAmount) > 0;
    },

    pointsConvertAmount: function() {
      var ratio = this.conversionRatio ? this.conversionRatio : 0.1;
      return Math.round(this.bpointsAmount * ratio);
    },

    maxConvertedAmount: function() {
      var ratio = this.conversionRatio ? this.conversionRatio : 0.1;
      return Math.round(this.maxPoints * ratio);
    },
    // },
    // mounted() {
    //   // vm.$forceUpdate();
    //   // console.log(this.parseObject);
  }
};
</script>
